import { Text, View } from "@react-pdf/renderer";
import { formatCurrency } from "../../Utils/formatCurrency";
import CfmReportStyles from "../../CfmReportStyles";
import PageWrapper from "../../Components/PageWrapper";

const columns = [
  { key: "age", label: "Age" },
  { key: "pensionRegularIncome", label: "Pension Regular Income" },
  { key: "taxFreeCash", label: "TFLS" },
  { key: "taxedDrawdown", label: "Taxed Drawdown" },
  { key: "pensionAdhocContribution", label: "Pension Ad-Hoc Contribution" },
  { key: "pensionAdhocWithdrawal", label: "Pension Ad-Hoc Withdrawal" },
  { key: "investmentRegularIncome", label: "Investment Regular Income" },
  {
    key: "investmentAdhocContribution",
    label: "Investment Ad-Hoc Contribution",
  },
  { key: "investmentAdhocWithdrawal", label: "Investment Ad-Hoc Withdrawal" },
  { key: "btlRental", label: "BTL/Rental" },
  { key: "dbPension", label: "DB Pension" },
  { key: "statePension", label: "State Pension" },
  { key: "salary", label: "Salary" },
  { key: "otherIncome", label: "Other Income" },
  { key: "regularExpenditure", label: "Regular Expenditure" },
  { key: "totalGrossIncome", label: "Total Gross Income" },
  { key: "taxableIncome", label: "Taxable Income" },
  { key: "totalIncomeAfterTax", label: "Total Income After Tax" },
  { key: "totalExpenditure", label: "Total Expenditure" },
  { key: "surplusDeficit", label: "Surplus/ Deficit" },
];

const CHUNK_SIZE = 18;

const IncomeExpenditureResultsSection = ({
  incomeResults,
  details,
  primaryColor,
  tradingName,
  footerText,
}) => {
  if (!incomeResults?.length) return null;

  // console.log(incomeResults);

  const styles = CfmReportStyles(primaryColor);

  return (
    <>
      {incomeResults.map((entry, idx) => {
        const data = entry.incomeExpenditure || [];

        // determine active columns
        const activeColumns = columns.filter((col) => {
          if (col.key === "age") return true;
          return data.some((row) => row[col.key] !== "£0.00");
        });

        const omittedColumns = columns
          .filter((col) => !activeColumns.includes(col))
          .map((col) => col.label);

        // console.log(
        //   `IncomeExpenditureResultsSection - columns omitted for ${entry.name}:`,
        //   omittedColumns.length ? omittedColumns.join(", ") : "None"
        // );

        // split into page chunks
        const chunks = [];
        const matchedPerson = details.find((p) => p.name === entry.name);
        const retirementAge = Number(matchedPerson?.retirementAge);

        for (let i = 0; i < data.length; i += CHUNK_SIZE) {
          chunks.push(data.slice(i, i + CHUNK_SIZE));
        }

        return chunks.map((chunk, chunkIndex) => (
          <PageWrapper
            key={`${entry.name}-${chunkIndex}`}
            size="A4"
            orientation="landscape"
            style={styles.page}
            primaryColor={primaryColor}
            tradingName={tradingName}
            headerTitle={
              chunkIndex === 0
                ? `${entry.name} - Total Income & Expenditure Overview`
                : `${entry.name} - Total Income & Expenditure Overview (continued)`
            }
            headerSubText={entry.type || "Summary"}
            footerText={footerText}
          >
            <View style={{ padding: 16 }}>
              <View style={styles.tableWrapper}>
                <View style={styles.tableHeader}>
                  {activeColumns.map((col) => (
                    <Text
                      key={`${col.key}-header`}
                      style={[
                        styles.tableCell,
                        styles.tableHeaderText,
                        col.key === "age" && styles.ageCell,
                      ]}
                    >
                      {col.label}
                    </Text>
                  ))}
                </View>

                {chunk.map((fund, i) => {
                  const isRetirementAge = Number(fund.age) === retirementAge;

                  return (
                    <View
                      key={`${entry.name}-${fund.age}`}
                      style={[
                        styles.tableRow,
                        i % 2 === 1 && styles.altRow,
                        isRetirementAge && styles.highlightRow,
                      ]}
                    >
                      {activeColumns.map((col) => (
                        <Text
                          key={`${col.key}-${fund.age}`}
                          style={[
                            styles.tableCell,
                            col.key === "age" && styles.ageCell,
                          ]}
                        >
                          {col.key === "age"
                            ? fund[col.key]
                            : formatCurrency(fund[col.key])}
                        </Text>
                      ))}
                    </View>
                  );
                })}
              </View>
            </View>
          </PageWrapper>
        ));
      })}
    </>
  );
};

export default IncomeExpenditureResultsSection;
